module.exports = __webpack_public_path__ + "media/17.3dac16a2.mp3";